/**
 * HOST PORTAL shell for the Connect team.
 *
 * The layout and Cloudflare Access identity card are @alight/enrolment-ui,
 * shared with apps/site and apps/htbh — the team gets the same portal against
 * Connect's own database. The NAV is Connect's own: the inbox, individual
 * registrations (routes/admin/registrations.tsx), the Site content CMS, then
 * the shared Programs / Forms / Assets / Settings screens. The shared
 * parent/child sections (Submissions, Children, Attendance, …) are left out —
 * Connect registrants are individuals (docs/CONNECT-SYDNEY.md).
 *
 * The whole `/admin/*` group sits behind Cloudflare Access at the edge — by the
 * time this renders the operator has already authenticated, and the Worker
 * re-verifies the Access JWT on every `/api/admin/*` call. The root layout
 * drops the public Nav/Footer for these routes.
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CalendarDays, ClipboardList, Image, Inbox, LayoutTemplate, ListChecks, Settings, Users } from "lucide-react";
import { AdminLayout, type AdminNavLink } from "@alight/enrolment-ui";
import { useSeo } from "../lib/seo";

export const Route = createFileRoute("/admin")({
  component: AdminRoute,
});

const CONNECT_ADMIN_LINKS: AdminNavLink[] = [
  { label: "Inbox", to: "/admin", icon: Inbox },
  { label: "Registrations", to: "/admin/registrations", icon: ClipboardList },
  { label: "Site content", to: "/admin/content", icon: LayoutTemplate },
  { label: "Team", to: "/admin/team", icon: Users },
  { label: "Programs", to: "/admin/programs", icon: CalendarDays },
  { label: "Forms", to: "/admin/forms", icon: ListChecks },
  { label: "Assets", to: "/admin/assets", icon: Image },
  { label: "Settings", to: "/admin/settings", icon: Settings },
];

function AdminRoute() {
  useSeo({ title: "Host Portal | Connect Sydney", noindex: true });
  return (
    <AdminLayout orgLabel="Connect Sydney" links={CONNECT_ADMIN_LINKS}>
      <Outlet />
    </AdminLayout>
  );
}
